import {AxiosPromise} from "axios";
import RequestHelper, {ActionAnswer} from "../utils/RequestsHelper";

export default class LongActionStatusApi {
    public static status(id?: number, action?: string): AxiosPromise<ActionAnswer<CliTask>> {
        action = action ? action : "backend"
        return RequestHelper.send("get", action, {processId:id})
    }
}

export interface CliTask {
    id: string
    has_started: string
    data?:string
    end_date?:string
    is_running?: string
    is_completed: string
    error: string
    text: string
    type: string
}